export type KpiTranslationKey =
  | 'kpis.clusterSize.title'
  | 'kpis.clusterSize.subtitle'
  | 'kpis.totalReach.title'
  | 'kpis.totalReach.subtitle'
  | 'kpis.totalReach.badge'
  | 'kpis.totalImpressions.title'
  | 'kpis.totalImpressions.subtitle'
  | 'kpis.totalCost.title'
  | 'kpis.totalCost.subtitle';

export type KpiConfig = {
  titleKey: KpiTranslationKey;
  subtitleKey: KpiTranslationKey;
  badgeKey?: KpiTranslationKey;
};

export const KPI_CONFIG: Record<string, KpiConfig> = {
  clusterSize: {
    titleKey: 'kpis.clusterSize.title',
    subtitleKey: 'kpis.clusterSize.subtitle',
  },
  totalReach: {
    titleKey: 'kpis.totalReach.title',
    subtitleKey: 'kpis.totalReach.subtitle',
    badgeKey: 'kpis.totalReach.badge',
  },
  totalImpressions: {
    titleKey: 'kpis.totalImpressions.title',
    subtitleKey: 'kpis.totalImpressions.subtitle',
  },
  totalCost: {
    titleKey: 'kpis.totalCost.title',
    subtitleKey: 'kpis.totalCost.subtitle',
  },
};
